import Enumerable from 'linq'
import { SearchOptions, SearchParameters } from './type'

export const getSearchOptionDefaultValue = <TRequest>(option: SearchOptions<TRequest>) =>
  option.defaultValue ?? (option.valueType === 'boolean' ? false : undefined)


export const getSearchParameterValue = <TRequest>(
  option: SearchOptions<TRequest>,
  params: SearchParameters,
) => option.valueType === 'boolean' ? !!params.value : params.value

export const isSearchParameterActive = <TRequest>(
  option: SearchOptions<TRequest>,
  params: SearchParameters,
) => option.valueType === 'threeState' ? typeof params.value === 'boolean' : params.isActive

export const applySearchParameters = <TRequest extends object>(
  parameters: SearchParameters[],
  options: SearchOptions<TRequest>[],
  request: TRequest,
) => {
  Enumerable.from(parameters)
    .groupJoin(
      options,
      op => op.key,
      pr => pr.key,
      (params, optionsEnumerable) => ({ option: optionsEnumerable.firstOrDefault(), params })
    )
    .where(({ option, params }) => !!option && isSearchParameterActive(option, params))
    .forEach(({ option, params }) => option!.setValue({
      ...params,
      value: getSearchParameterValue(option!, params),
    }, request))

  return request
}
